import type { HTMLAttributes, ReactNode } from "react";

type Tone = "active" | "overdue" | "pending" | "closed" | "draft" | "on-brand" | "on-ink";

interface PillProps extends Omit<HTMLAttributes<HTMLSpanElement>, "className" | "children"> {
  tone: Tone;
  sm?: boolean;
  /** Leading 6px status dot (default true). */
  dot?: boolean;
  children: ReactNode;
}

// Status pill (UI System v2). Status tones map to `.st-*`; on-brand / on-ink are surface variants.
// Other attributes (`data-r`, a stagger `style`) go to the span, so an eyebrow pill can be a direct
// flex child like the prototype — an extra wrapper adds a line box and makes the pill 1px taller.
export function Pill({ tone, sm, dot = true, children, ...rest }: PillProps) {
  const toneCls = tone === "on-brand" || tone === "on-ink" ? tone : `st-${tone}`;
  const cls = ["pill", toneCls, sm && "sm", !dot && "nodot"].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
